//password eye function
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".toggle-password").forEach(function (toggleBtn) {
    // Prevent attaching duplicate listeners
    if (toggleBtn.dataset.attached === "true") return;
    toggleBtn.dataset.attached = "true";
    
    const wrapper = toggleBtn.closest(".field");
    const passwordInput = wrapper.querySelector(
      "input[type='password'], input[type='text']"
    );
    const eyeIcon = toggleBtn.querySelector(".eye-icon");
    const eyeFilledIcon = toggleBtn.querySelector(".eye-filled-icon");

    toggleBtn.addEventListener("click", function () {
      if (!passwordInput) return;

      const isPassword = passwordInput.getAttribute("type") === "password";
      passwordInput.setAttribute("type", isPassword ? "text" : "password");

      eyeIcon.classList.toggle("hidden", isPassword);
      eyeFilledIcon.classList.toggle("hidden", !isPassword);

      toggleBtn.setAttribute(
        "aria-label",
        isPassword ? "Hide password" : "Show password"
      );
    });
  });
});

//password strenght
(function () {
  function initPasswordStrength() {
    // Find all register sections (either on page or in modal)
    const registerSections = document.querySelectorAll('[id^="Register-"]');

    registerSections.forEach((section) => {
      // Prevent double-binding
      if (section.dataset.strengthAttached === "true") return;
      section.dataset.strengthAttached = "true";

      const input = section.querySelector('[data-password-input]');
      const barsWrap = section.querySelector('[data-password-strength-bars]');
      const hint = section.querySelector('[data-password-hint]');

      if (!input || !barsWrap || !hint) return;

      const bars = barsWrap.querySelectorAll("[data-bar]");
      const t = hint.dataset;

      function updatePasswordHint(strength) {
        hint.classList.remove("hidden");
        const t = hint.dataset;

        if (strength === 0 || strength === 1) {
          hint.textContent = t.passwordRequirements;
        } else if (strength === 2) {
          hint.innerHTML = `${t.passwordStrength}: <span class="font-bold">${t.weak}</span>`;
        } else if (strength === 3) {
          hint.innerHTML = `${t.passwordStrength}: <span class="font-bold">${t.good}</span>`;
        } else if (strength === 4) {
          hint.innerHTML = `${t.passwordStrength}: <span class="font-bold">${t.strong}</span>`;
        }
      }

      function render(strength) {
        bars.forEach((bar) => {
          bar.classList.remove("bar--red", "bar--yellow", "bar--green");
        });

        for (let i = 0; i < strength; i++) {
          if (strength === 1) bars[i].classList.add("bar--red");
          else if (strength === 2) bars[i].classList.add("bar--yellow");
          else bars[i].classList.add("bar--green");
        }
        updatePasswordHint(strength);
      }

      function evaluate(val) {
        const hasLetter = /[A-Za-z]/.test(val);
        const hasNumber = /\d/.test(val);
        const hasSpecial = /[^A-Za-z0-9]/.test(val);
        const len = val.length;

        let strength = 0;
        if (len === 0) strength = 0;
        else if (!hasLetter || !hasNumber || len < 8) strength = 1;
        else {
          if (len >= 15) strength = 4;
          else if (len >= 11) strength = hasSpecial ? 4 : 3;
          else strength = hasSpecial ? 3 : 2;
        }
        render(strength);
      }

      input.addEventListener("input", (e) => evaluate(e.target.value));
      input.addEventListener("change", (e) => evaluate(e.target.value));

      document.body.addEventListener("modalClosed", () => {
        const isInsideModal = section.closest('.modal, [id*="Modal"]');
        if (!isInsideModal) return;

        evaluate("");
        hint.classList.add("hidden");
      });

      evaluate(input.value || "");
      
      // Catch autofill that might happen shortly after initialization
      setTimeout(() => evaluate(input.value || ""), 500);
    });
  }

  document.addEventListener("DOMContentLoaded", initPasswordStrength);
  document.addEventListener("shopify:section:load", initPasswordStrength);
  // Also watch for modal openings as sections might be rendered/shown then
  window.addEventListener("modaldialog:opened", initPasswordStrength);
})();
